import { create } from "zustand";
import { Step } from "~/lib/pipeline";
import { JobStates } from "~/components/build/Show/lib/types";

export type WaterfallBarType = {
  limited: {
    start_percentage: number;
    percentage: number;
    duration: string;
  };
  active: {
    start_percentage: number;
    waiting_percentage: number;
    waiting_duration: string;
    dispatching_percentage: number;
    dispatching_duration: string;
    running_percentage: number;
    running_duration: string;
    total_percentage: number;
    total_duration: string;
  };
  passed: boolean;
  step_uuid?: string;
  job_uuid?: string;
  job_url?: string;
  parent: boolean;
};

export type WaterfallRowType = {
  bars: WaterfallBarType[];
  children: WaterfallRowType[];
  end_time: null | string;
  type: Step["type"];
  job_uuid?: string;
  step_uuid: string;
  job_url?: string | null;
  job_state?: JobStates;
  job_passed?: boolean;
  job_soft_failed?: boolean;
  label: { text: string; format: "emojify" | "code" | "raw" };
  start_time: null | string;
  duration: string;
} & ({ parallel_group_index: number; parallel_group_total: number } | undefined);

export type WaterfallData = {
  chart_data: WaterfallRowType[];
  bar_container_padding: number;
};

interface WaterfallStore {
  data: WaterfallData | null;
  setData: (data: WaterfallData) => void;
}

export const useWaterfallStore = create<WaterfallStore>((set) => ({
  data: null,
  setData: (data) => set({ data }),
}));
